//#region src/assets/vana-card-blue.svg
var vana_card_blue_default = "" + new URL("vana-card-blue-Boc9Rgsb.svg", import.meta.url).href;
//#endregion
export { vana_card_blue_default as default };

//# sourceMappingURL=vana-card-blue.js.map